import React from 'react';
import List from './List';
import graph from './graph';
import { BaseModel } from 'components';

export default function Model(props) {
  return (
    <BaseModel graph={graph} {...props}>
      <List />
    </BaseModel>
  );
}
